export const NAME_COLUMN_MIN_WIDTH = 100;
export const COUNT_COLUMN_WIDTH = 85;
export const HIDE_ON_IPAD_COLUMN_WIDTH = 50;
export const PRICE_COLUMN_WIDTH = 90;
export const DISABLED_COLUMN_WIDTH = 70;
export const DEFAULT_VALUE_COLUMN_WIDTH = 80;
export const DELETE_COLUMN_WIDTH = 12;
export const DEPOSIT_COLUMN_WIDTH = 100;
export const OPTION_EDIT_DEPOSIT_COLUMN_WIDTH = 140;
export const INPUT_WIDTH = 70;
